const set = prop => (state, val) => {
  state[prop] = val
}

export const firstLoad = set('firstLoad')
export const authed = set('authed')
export const verified = set('verified')
export const user = set('user')
export const userProjects = set('userProjects')
export const loading = set('loading')
export const settings = set('settings')
export const menuRightCls = set('menuRightCls')

export const showAdmin = set('showAdmin')



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js